<div [@pageTransition]>
    <section class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <div class="card flex items-center gap-3">
            <div class="bg-gradient-to-br from-emerald-500 to-emerald-700 py-2 px-3 rounded-lg text-white">
                <span class="bi bi-calendar-event text-3xl"></span>
            </div>
            <div>
                <h4 class="text-xl font-bold">25</h4>
                <p class="text-md text-gray-400">Total Events</p>
            </div>
        </div>
        <div class="card flex items-center gap-3">
            <div class="bg-gradient-to-br from-orange-500 to-orange-700 py-2 px-3 rounded-lg text-white">
                <span class="bi bi-ticket-perforated text-3xl"></span>
            </div>
            <div>
                <h4 class="text-xl font-bold">2560+</h4>
                <p class="text-md text-gray-400">Total Ticket Sold</p>
            </div>
        </div>
        <div class="card flex items-center gap-3">
            <div class="bg-gradient-to-br from-violet-500 to-violet-700 py-2 px-3 rounded-lg text-white">
                <span class="bi bi-people-fill text-3xl"></span>
            </div>
            <div>
                <h4 class="text-xl font-bold">5000+</h4>
                <p class="text-md text-gray-400">Total Registration</p>
            </div>
        </div>
        <div class="card flex items-center gap-3">
            <div class="bg-gradient-to-br from-cyan-500 to-cyan-700 py-2 px-3 rounded-lg text-white">
                <span class="bi bi-cash-stack text-3xl"></span>
            </div>
            <div>
                <h4 class="text-xl font-bold">$8000</h4>
                <p class="text-md text-gray-400">Total Revenue</p>
            </div>
        </div>
    </section>
    
    <div class="my-5"></div>
    
   
    
    <section class="grid grid-cols-1 my-4 xl:grid-cols-2 2xl:grid-cols-3 gap-5">
        <div class="card p-8">
            <div class="card-title flex justify-between items-center mb-4">
                <h3 class="text-xl font-bold leading-none">Latest Customers</h3>
                <a href="#" class="inline-flex items-center p-2 text-sm font-medium rounded-lg hover:bg-gray-100">
                    View all
                </a>
            </div>
            <div class="flow-root">
                <ul role="list" class="divide-y divide-gray-200">
                    <li class="py-3 sm:py-4" *ngFor="let i of [200, 325, 100, 50, 400, 336]">
                        <div class="flex items-center space-x-4">
                            <div class="flex-shrink-0">
                                <img class="w-8 h-8 rounded-full" src="https://placehold.co/100x100" alt="user image">
                            </div>
                            <div class="flex-1 min-w-0">
                                <p class="text-sm font-medium text-gray-900 truncate">
                                    John Doe
                                </p>
                                <p class="text-sm text-gray-500 truncate">
                                    john.deo&#64;email.com
                                </p>
                            </div>
                            <div class="inline-flex items-center text-base font-semibold text-gray-900">
                                ${{i}}
                            </div>
                        </div>
                    </li>
                </ul>
    
                <div class="flex justify-between font-medium text-sm pt-5">
                    <div class="text-gray-400">
                        <h5 class="inline-flex">Total</h5>
                        6 of 300
                    </div>
                    <a href="" class="inline-flex text-emerald-500">
                        View Sales Report
                    </a>
                </div>
            </div>
        </div>
    
        
    </section>
</div>
